import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @ts-expect-error package not converted to TS
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import LoginDao from '../../data/LoginDao';
import { useRedirect } from '../../hooks/useRedirect';
import TwoFactorAuthStatuses from '../../constants/TwoFactorAuthStatuses';
import ConfirmToLoginAuthStatuses from '../../constants/ConfirmToLoginAuthStatuses';
import SsoRequiredAuthStatuses from '../../constants/SsoRequiredAuthStatuses';
const loginDao = new LoginDao();
export const useConfirmationLanding = loginType => {
  const [error, setError] = useState();
  const {
    search
  } = useLocation();
  const appCookieLogin = useMemo(() => {
    const asyncCall = {
      MICROSOFT: loginDao.microsoftLogin.bind(loginDao)
    };
    return new HubSpotOnlyAppCookieLogin({
      loginRequest: asyncCall[loginType],
      passThroughFallback: true
    });
  }, [loginType]); // parse query params

  const credentials = useMemo(() => {
    const qp = new URLSearchParams(search);
    return Object.fromEntries([...qp]);
  }, [search]); // response and redirect handlers

  const {
    redirectToSsoRequired,
    redirectToSuspiciousUser,
    redirectToTwoFactorRequired
  } = useRedirect(credentials); // onLoad handler

  const onLoad = useCallback(() => {
    appCookieLogin.login().then(responses => {
      const response = responses[0];

      switch (response.status) {
        case TwoFactorAuthStatuses.TWO_FACTOR_REQUIRED:
          return redirectToTwoFactorRequired(response);

        case ConfirmToLoginAuthStatuses.SUSPICIOUS_USER_MUST_CONFIRM:
          return redirectToSuspiciousUser(response);

        case SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED:
          return redirectToSsoRequired(response);

        default:
          return appCookieLogin.redirectOnLoginSuccess(responses);
      }
    }).catch(err => {
      setError(err);
    });
  }, [setError, appCookieLogin, redirectToSsoRequired, redirectToSuspiciousUser, redirectToTwoFactorRequired]);
  return {
    error,
    onLoad
  };
};